import { TranslateModule } from '@ngx-translate/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

import { FileHashPipe } from '@iss/wo-common/hash-files';

@Component({
  selector: 'iss-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: [ './global-spinner.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ NgIf, TranslateModule, FileHashPipe ],
})
export class GlobalSpinnerComponent {
  @Input() visible?: boolean | null;
}
